import utils from 'utils';
import { gmiRequest } from 'actions/request';
import actions from '@ehi/global-marketing-interface/lib/actions';
import services from '@ehi/global-marketing-interface/lib/services';

export const addAdditionalDriverDetails = (formData) => (dispatch) => {
  const data = {};
  data.payload = utils.driverProfile.driverProfilePayloadParser(formData);

  if (formData?.reservation_token) {
    data.payload.reservation_token = formData.reservation_token;
  }

  return dispatch(
    gmiRequest({
      action: actions.request({
        service: services.gma.reservations.addAdditionalDriver,
        data,
      }),
    })
  );
};
